import { registerEntryPoint } from "./entrypoint";
import { registerIslandModule } from "./components";


registerEntryPoint("mfa/webauthn/login", () => import("./mfa/webauthn/login"));
registerEntryPoint("mfa/webauthn/setup", () => import("./mfa/webauthn/setup"));
registerEntryPoint("external_fee/upload", () => import("./external_fee_upload"));
registerIslandModule("graphiql", () => import("./grpahiql"));

